/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import TranslationsTable from 'dnb-design-system-portal/src/shared/parts/TranslationsTable';
import {GlobalStatusExampleControllers} from 'Docs/uilib/components/global-status/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    strong: "strong",
    a: "a",
    pre: "pre",
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Properties"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the main ID. Defaults to ", _jsx(_components.code, {
              children: "main"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "title"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the title appears as a part of the status content. Defaults to ", _jsx(_components.code, {
              children: "En feil har skjedd"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "text"
            }), " or ", _jsx(_components.code, {
              children: "children"
            })]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the text appears as the status content. Besides plain text, you can send in a React component as well. Defaults to ", _jsx(_components.code, {
              children: "null"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "items"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the items (list items) appear as a part of the status content. you can both use an JSON array, or a vanilla array with a string or an object content. See ", _jsx(_components.strong, {
              children: "Item Object"
            }), " example below."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the icon shown before the status title. Defaults to ", _jsx(_components.code, {
              children: "exclamation"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "state"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the visual appearance of the status. There are four main statuses ", _jsx(_components.code, {
              children: "error"
            }), ", ", _jsx(_components.code, {
              children: "warning"
            }), ", ", _jsx(_components.code, {
              children: "info"
            }), " and ", _jsx(_components.code, {
              children: "success"
            }), ". The default status is ", _jsx(_components.code, {
              children: "error"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "icon_size"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the icon size of the title icon shows. Defaults to ", _jsx(_components.code, {
              children: "medium"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "show"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " or ", _jsx(_components.code, {
              children: "false"
            }), " to manually make the global status visible. Defaults to ", _jsx(_components.code, {
              children: "true"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "autoclose"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " to automatically close the global status if there are no more left items in the provider stack. Defaults to ", _jsx(_components.code, {
              children: "true"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "autoscroll"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " to automatically scroll the page to the appeared global status. Defaults to ", _jsx(_components.code, {
              children: "true"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "no_animation"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " to disable the show/hide/slide/fade/grow/shrink animation. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "delay"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the delay on how long the automated visibility should wait before it appears to the user. Defaults to ", _jsx(_components.code, {
              children: "200ms"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hide_close_button"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " if the close button should be hidden for the user. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "close_text"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " text of the close button. Defaults to ", _jsx(_components.code, {
              children: "Lukk"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_anchor_text"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the anchor text showing up after every item, in case there is a ", _jsx(_components.code, {
              children: "status_id"
            }), " defined. Defaults to ", _jsx(_components.code, {
              children: "Gå til %s"
            }), ". The ", _jsx(_components.code, {
              children: "%s"
            }), " represents the optional and internal handled label addition."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "omit_set_focus"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " to omit setting the focus during visibility. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), ". Additionally, there is ", _jsx(_components.code, {
              children: "omit_set_focus_on_update"
            }), " which is set to ", _jsx(_components.code, {
              children: "true"
            }), " by default."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "/uilib/layout/space/properties",
              children: "Space"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " spacing properties like ", _jsx(_components.code, {
              children: "top"
            }), " or ", _jsx(_components.code, {
              children: "bottom"
            }), " are supported."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Translations"
    }), "\n", _jsx(TranslationsTable, {
      localeKey: "GlobalStatus"
    }), "\n", _jsx(_components.h2, {
      children: "Item Object"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "// simple\nconst items = ['Item #1', 'Item #2']\n\n// advanced\nconst items = [\n  { text: 'Item #1', status_id: 'id-1' },\n  { text: 'Item #2', status_id: 'id-2', status_anchor_url: 'https://' },\n]\n"
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Advanced Item Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "text"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " the text appears as the status content. Beside plain text, you can send in a React component as well."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(required)"
            }), " defines an unique ID so the message can be either updated or removed individual."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_anchor_url"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Use ", _jsx(_components.code, {
              children: "status_anchor_url={true}"
            }), " to enable the go-to link, defined as a url hash using the ", _jsx(_components.code, {
              children: "status_id"
            }), ". Or provide it with an actual url: ", _jsx(_components.code, {
              children: "status_anchor_url=\"https://\""
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_anchor_text"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " defines the anchor text showing up after every item. Defaults to ", _jsx(_components.code, {
              children: "Gå til %s"
            }), ". The ", _jsx(_components.code, {
              children: "%s"
            }), " represents the optional and internal handled label addition."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_anchor_label"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " adds an additional text to the anchor (replaces ", _jsx(_components.code, {
              children: "%s"
            }), "), showing up after every item. Is used by default by other form components, if they have an ", _jsx(_components.code, {
              children: "label"
            }), "."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Controllers"
    }), "\n", _jsx(_components.p, {
      children: "In React, you can make use of the helper components, the function as a kind of a controller component.\nThe goal is to update the content (properties/events) of the target GlobalStatus."
    }), "\n", _jsx(GlobalStatusExampleControllers, {}), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Controller Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the main ID. Defaults to ", _jsx(_components.code, {
              children: "main"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "status_id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " define a new stack ID so you can remove it with the same ID later on. Defaults to ", _jsx(_components.code, {
              children: "null"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "remove_on_unmount"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " set to ", _jsx(_components.code, {
              children: "true"
            }), " if you want that the component ", _jsx(_components.code, {
              children: "<GlobalStatus.Add remove_on_unmount={true} ... />"
            }), " should automatically remove the stacked status from the target ", _jsx(_components.strong, {
              children: "GlobalStatus"
            }), " on component unmount. Defaults to ", _jsx(_components.code, {
              children: "false"
            }), "."]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Configuration Object"
    }), "\n", _jsxs(_components.p, {
      children: ["This object is used as a representation to configure the GlobalStatus component from other components, using the ", _jsx(_components.code, {
        children: "globalStatus"
      }), " property.\nSee ", _jsx(_components.a, {
        href: "/uilib/components/autocomplete/properties",
        children: "Autocomplete"
      }), ", ", _jsx(_components.a, {
        href: "/uilib/components/button/properties",
        children: "Button"
      }), ", ", _jsx(_components.a, {
        href: "/uilib/components/input/properties",
        children: "Input"
      }), ", etc, as examples that use the ", _jsx(_components.code, {
        children: "globalStatus"
      }), " property."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "{\n  id: 'global-status-id',\n  message: 'global status message'\n}\n"
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Configuration Object Properties"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "id"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the main ID. Defaults to ", _jsx(_components.code, {
              children: "main"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "message"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " the text appears as the status content. Besides plain text, you can send in a React component as well. Defaults to null."]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
